import { render, staticRenderFns } from "./ConfiguracoesEcac.vue?vue&type=template&id=2c1ee639&"
import script from "./ConfiguracoesEcac.vue?vue&type=script&lang=js&"
export * from "./ConfiguracoesEcac.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracoesEcac.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports